import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {
  businessCashAdvanceApprovedRoute,
  businessCashAdvanceCalculationRoute,
  businessCashAdvanceDashboardRoute,
  businessCashAdvanceDigitalTermsRoute,
  businessCashAdvanceNoQualifyRoute,
  businessCashAdvancePreApprovedRoute,
  businessCashAdvanceRoute,
  businessCashAdvanceTopUpCalculationRoute,
  businessCashAdvanceTopUpContractRoute,
} from 'src/routing/routes';
import BusinessCashAdvanceApproved from './approved/business-cash-advance-approved';
import BusinessCashAdvanceCalculation from './calculation/business-cash-advance-calculation';
import BCADashboard from './dashboard/dashboard';
import BusinessCashAdvanceDigitalTerms from './digital-terms/business-cash-advance-digital-terms';
import BCAGetFinanced from './get-financed/get-financed';
import BusinessCashAdvanceNoQualify from './no-qualify/business-cash-advance-no-qualify';
import BusinessCashAdvancePreApproved from './pre-approved/business-cash-advance-pre-approved';
import { PageNotFound } from 'src/containers';
import BusinessCashAdvanceTopUpCalculation from 'src/containers/self-service/business-cash-advance/calculation/business-cash-advance-top-up-calculation';
import { BusinessCashAdvanceTopUpContract } from 'src/containers/self-service/business-cash-advance/top-up-contract/business-cash-advance-top-up-contract';

import './business-cash-advance.scss';

export default function BusinessCashAdvance() {
  return (
    <div className="BusinessCashAdvance">
      <Switch>
        <Route
          exact
          path={businessCashAdvancePreApprovedRoute}
          component={BusinessCashAdvancePreApproved}
        />
        <Route
          exact
          path={businessCashAdvanceNoQualifyRoute}
          component={BusinessCashAdvanceNoQualify}
        />
        <Route
          exact
          path={businessCashAdvanceCalculationRoute}
          component={BusinessCashAdvanceCalculation}
        />
        <Route
          exact
          path={businessCashAdvanceDigitalTermsRoute}
          component={BusinessCashAdvanceDigitalTerms}
        />
        <Route
          exact
          path={businessCashAdvanceTopUpCalculationRoute}
          component={BusinessCashAdvanceTopUpCalculation}
        />
        <Route
          exact
          path={businessCashAdvanceTopUpContractRoute}
          component={BusinessCashAdvanceTopUpContract}
        />
        <Route
          exact
          path={businessCashAdvanceApprovedRoute}
          component={BusinessCashAdvanceApproved}
        />
        <Route exact path={businessCashAdvanceRoute} component={BCAGetFinanced} />
        <Route exact path={businessCashAdvanceDashboardRoute} component={BCADashboard} />
        <Route component={PageNotFound} />
      </Switch>
    </div>
  );
}
